<template>
	<div>
		<!-- 编辑电站 -->
		<newPlant ref="newPlant" @AfterEdit="AfterEdit" v-if="SonComponents.editStation"></newPlant>
		<!-- 删除电站 -->
		<ConfirmDevice ref="confirmDelStation" @confirm="confirmDelStation" v-if="SonComponents.delStation"></ConfirmDevice>
		<!-- 关联人 -->
		<AddPerson ref="AddPerson" v-if="SonComponents.addPerson" @refresh="refreshPersonList"></AddPerson>
		<!-- 编辑标签 -->
		<TagManageForObject :type="1" ref="TagManage" @Update="UpdateTags"></TagManageForObject>
		 <!-- 关联 -->
		<RelevancePart ref="RelevancePart" @Update="UpdateRelevance" :powerType="'light'"></RelevancePart>
		<AddChildSys ref="AddChildSys" @refreshChildSys="refreshChildSys"></AddChildSys>
		<ConfirmDevice ref="confirmDelChild" @confirm="delChild"></ConfirmDevice>
		<!-- 添加直联设备 -->
		<AddContentsDevices ref="AddContentsDevices" @refresh="AddDeviceSuccess" :timezone="basicInfo.region.timezone"></AddContentsDevices>
		<!-- 再次添加直连设备 -->
		<EditConentsDevices ref="EditConentsDevices" :timezone="basicInfo.region.timezone"></EditConentsDevices>
		<!--添加维保记录-->
		
		<NewMaintenance ref="NewMaintenance" :systemType="1" :systemTypeId="stationId" :systemTypeName="basicInfo.name" v-if="newMaintentceShow"></NewMaintenance>
		<!-- 编辑标签 -->
		<Window ref="Window" :bg='bg' :size="'full'" @Closed="myClose" :id="id">
			<confirm-meter-unconfig ref="confirmMeterUnconfig" id="confirmMeterUnconfig" @confirm="stepTo('ChildSys','AmmeterList')" :size="'m'" :title="$t('phrase598',['电表设备配置提醒'])" :okBtnText="$t('meter_configure2',['去配置'])" :cancelText="$t('meter_configure3',['下次再说'])">
				<!-- <div v-show="meterUnconfigList.length" class="mc mt2x">
					<button v-if="(meter,index) in meterUnconfigList" :key="index" class="cSub mr1x" @click="_meterSetup(meter)">{{meter.sn}}<span class="cError"> ( {{$t("word1359",["未配置"])}} ) </span></button>
				</div> -->
			</confirm-meter-unconfig>
			<!-- 电站设置 -->
			<!-- <station-config ref="stationConfig" @refreshOffset="_refresh" :basicInfo="basicInfo" v-if="SonComponents.stationConfig" :powerType="'light'" :systemId="stationId"></station-config> -->
			<!-- 外部权限列表 -->
			<PromiseList ref="PromiseList" :roleCode="roleCode"></PromiseList>
			<!-- <ConfirmDevice ref="confirmDevice" id="confirmDevice" @confirm="_delDeviceW" :title="confirmTitle"></ConfirmDevice> -->
			<ConfirmDevice ref="confirmRepeatSet" id="confirmRepeatSet" @confirm="systemSel" :cancelText="$t('word1361',['保留当前设置'])" :okBtnText="$t('word1362',['系统智能选择'])"></ConfirmDevice>
			<!--<repeat-warn ref="repeatWarn" @repeatSet="repeatSet" @noReminder="noReminder"></repeat-warn>-->
			<!-- <RealData ref="realData" :Data="updateData"></RealData> -->
			<!-- <MeterSetup ref="meterSetup" v-if="!meterIsEmpty" :meterInfo="meter" @meterSetSuccess="meterSetSuccess"></MeterSetup> -->
			<!-- 头部开始 -->
			<div slot="headButton" class="dpIB fSub_E hover-f-main_E tra-fast_E" v-show="systemType==0">
				<button v-show='hideB' class="hover-f-follow" type="button" @click="_isFollowing" :title="following?getLanguageStr('cmd262','解除关注'):$t('cmd167',['关注'])">
					<Icon :name="following?'star-on':'star-off'" :class="{'fFollow':following}" class="ico"/>
				</button>
				<div v-show='hideB' class="hasDropList-hover dpIB" v-if="addBtnFlag">
					<button type="button" :title="$t('cmd10',['添加'])">
						<Icon name="add" class="w1x h1x" :sizeBase="'m'"/>
					</button>
					<div class="dropList tra-fast tra-fast_E bdSub bgContent hover-bg-highLight_E">
						<a @click="_AddConnectsDevices(stationId,0)" v-permissions="'A/B/A8'" permission-type="none" v-if="doPermissions('A/B/A8',{targetCode:'A4',codeList:clone(roleCode)})">{{getLanguageStr("word723","网关/采集器")}}</a>
						<a @click="_editConnectDevices(stationId,0)" v-permissions="'A/B/A8'" permission-type="none" v-if="doPermissions('A/B/A8',{targetCode:'A4',codeList:clone(roleCode)})">{{getLanguageStr("word1530","子设备")}}</a>
						<a @click="_AddRetativePerson" v-if="relBtn">{{getLanguageStr("cmd59","授权")}}</a>
						<a @click="addMaintenance()" v-permissions="'C/A/A4'" permission-type="none" v-if="(doPermissions('C/A/A4',{targetCode:'A4',codeList:clone(roleCode)}))&&(!stage.setting.loc.shieldBlackList.maintenance)">{{getLanguageStr("word1992","维保记录")}}</a>
					</div>
				</div>
				<button v-show='hideB' v-permissions="'A/B/A3'" permission-type="none" class="hasDropList-hover dpIB" v-if="doPermissions('A/B/A3',{targetCode:'A1',codeList:clone(roleCode)})">
					<button class="hover-f-main" type="button">
						<Icon name="edit" class="w1x h1x" :sizeBase="'m'" />
					</button>
					<div v-if="doPermissions('A/B/A3',{targetCode:'A1',codeList:clone(roleCode)})" class="dropList tra-fast tra-fast_E bdSub bgContent hover-bg-highLight_E" style="left:-3em">
						<a :title="$t('word733',['电站信息'])" v-permissions="'A/B/A3'" permission-type="none" @click="editStation">{{getLanguageStr("word733","电站信息")}}</a>
						<a :title="getLanguageStr('word1909','系统布局')" @click="editLayout">{{getLanguageStr('word1909','系统布局')}}</a>
						<!-- <a @click="delStation"  v-permissions="'A/B/A5'" permission-type="none" v-if="JSON.stringify(data)!='{}' && entityRelId">{{getLanguageStr("从本商家解除","从本商家解除")}}</a> -->
					</div>
				</button>
				<div v-show='hideB' class="hasDropList-hover dpIB" v-if="moreBtnFlag">
					<button class="hover-f-main" type="button" :title="$t('word1356',['更多'])">
						<Icon name="etc-o" class="w1x h1x" :sizeBase="'m'"/>
					</button>
					<div class="dropList tra-fast tra-fast_E bdSub bgContent hover-bg-highLight_E" style="left:-3em">
						<a @click="_stageConfig"  v-permissions="'A/B/A4'" permission-type="none" v-if="doPermissions('A/B/A4',{targetCode:'A2',codeList:clone(roleCode)})">{{getLanguageStr("word1721","电站设置")}}</a>
						<a @click="delStation"  v-permissions="'A/B/A5'" permission-type="none" v-if="JSON.stringify(data)!='{}'">{{getLanguageStr("manage14","删除电站")}}</a>
						<!-- <a @click="delStation"  v-permissions="'A/B/A5'" permission-type="none" v-if="JSON.stringify(data)!='{}' && entityRelId">{{getLanguageStr("从本商家解除","从本商家解除")}}</a> -->
					</div>
				</div>
				<button :title="$t('cmd7',['刷新'])" type="button" @click="renovation(data)"><Icon name="refresh" class="w1x h1x" :sizeBase="'m'" /></button>
			</div>
			<div slot="headButton" class="dpIB fSub_E hover-f-main_E tra-fast_E" v-show="systemType==1">
				<button v-if="doPermissions('A/B/A9',{targetCode:'A5',codeList:clone(roleCode)})" :title="getLanguageStr('word1790','编辑子系统')" @click="editChildSys" type="button">
					<Icon name="edit" class="w1x h1x" :sizeBase="'m'"/>
				</button>
				<button v-if="doPermissions('A/B/A10',{targetCode:'A6',codeList:clone(roleCode)})" type="button" :title="getLanguageStr('cmd293','删除子系统')" @click="delChildSys">
					<Icon name="ico-recycle" class="w1x h1x" :sizeBase="'m'"/>
				</button>
				<button :title="$t('cmd7',['刷新'])" type="button" @click="showChildSys"><Icon name="refresh" class="w1x h1x" :sizeBase="'m'" /></button>
			</div>
			<div slot="head" class="cb">
				<div>
					<div class="dpIB vaM">
						<Select :name="'stationName'" :list="headerInfo.stationName" @Click="StationSelect" :bindActive="headerInfo.StationSelectValue" :styleType="'plantName'" class="w8x-min"></Select>
					<!--	<span v-else class="fs14x dpIB w15x-max textCut mr05x">{{basicInfo.name}}</span>-->
					</div>
					<div v-if="entityRelId" @click="$refs.PromiseList.show(basicInfo.entityRel)" class="dpIB cSub curP w40pct textCut vaM hover-c-main tra-fast" onclick="statistic('A13','A1352')"	>
					{{getLanguageStr('phrase715','当前电站来自外部，点击查看本商家对该电站的权限')}}
					</div>
					<!-- 数据来源重复提示弹框-begin -->
					<div class="dpIB dpIB_E vaM_E pl1x curP w50pct-max" @click="repeatShow" v-if="repeatState">
						<div class="icoSys w1x h1x fs14x"><svg class="fWhite"><use xlink:href="#ico-info"></use></svg></div>
						<span>{{$t('phrase596',['数据来源重复提示'])}}: {{$t('phrase599',['检测到电站中存在多种设备提供同类数据'])}}</span>
					</div>
					<!-- 数据来源重复提示弹框-end -->
				</div>
				<!-- 标签 -->
				<div class="dpB mt05x dpIB_E mr1x_E" v-if="systemType==0" v-permissions="'A/B/A16'" permission-type="none">
					<template  v-for="(item,index) in headerInfo.labels">
						<span class="tag" :key="index" :title="item.name" v-if="headerInfo.labels && index<3">
							{{item.name}}
						</span>
					</template>
					<span v-if="headerInfo.labels.length>3" :title="$t('fill3rd164',[headerInfo.labels.length,'等xx个标签'])">{{$t('fill3rd164',[headerInfo.labels.length,'等xx个标签'])}}</span>
					<span class="curP" @click="editLables" onclick="statistic('A23','A25')" :title="getLanguageStr('word1787','编辑所属标签')">{{getLanguageStr('word1787','编辑所属标签')}}</span>
				</div>
				<div class="mt1x clearfix vaM_E">
					<div class="dpIB dpIB_E" v-if="JSON.stringify(stationInfo)!='{}'">
						<div v-if="stationInfo.networkStatus" :class="judge(entityRelId,'ChildSys',roleCode)?'curP':''" @click="judge(entityRelId,'ChildSys',roleCode)?statusStepTo(stationInfo.networkStatus,'ChildSys'):''">
							<StatusIco :id="stationInfo.networkStatus" :type="'plant'" class="statueIcon"></StatusIco>{{getTypeText(stationInfo.networkStatus,'netStatus')}}
						</div>
						<Help :code="'accessing'" :btnClose="false" class="miniHelp" v-if="stationInfo.networkStatus=='NO_DEVICE'"></Help>
						<div class="ml1x" v-if="stationInfo.warningStatus" :class="judge(entityRelId,'Alarm',roleCode)?'curP':''" @click="judge(entityRelId,'Alarm',roleCode)?statusStepTo(stationInfo.warningStatus,'Alarm'):''"><StatusIco :id="stationInfo.warningStatus" :type="'alarm'" class="statueIcon"></StatusIco>{{getTypeText(stationInfo.warningStatus,'alarmStatus')}}</div>
						<Help :code="'alarming'" :btnClose="false"  class="miniHelp" v-if="stationInfo.warningStatus=='ALERTING'"></Help>
					</div>
					<div class="fR">
						<span v-if="stationInfo.lastUpdateTime">{{timeFormat(stationInfo.lastUpdateTime,'utc','%Y/%m/%d %H:%M:%S UTC',{offset:basicInfo.region.timezone})}}</span><span v-else>--</span>
						<!--  -->
						<!-- &nbsp;&nbsp;<span v-if="stationInfo.lastUpdateTime">{{mz(stationInfo.lastUpdateTime)}}</span> -->
					</div>
				</div>
			</div>
			<!-- 头部结束end -->
			<div v-if="systemType==0">
				<div class="navBtn pl1x bdSub-bottom-notLast">
					<div v-if="btnGroup.length" class="tabBar style-tabBar cb active-c-main_E tra-fast_E" :class="{disable:!basicInfo.id||!headerInfo.StationSelectValue}">
						<button v-for="(item,index) in btnGroup" :key="index" class="cSub afterButton" :class="{active:index==currentIndex}" @click="changeBtn(index)" v-if="!item.settingLocShow">{{item.title}}</button>
						<!-- <button v-for="(item,index) in btnGroup" v-if="item.ExterPermas==''||objTool(roleCode,'findByKeyFuzzy',['code',item.ExterPermas])[1].isOn==2" :key="index" class="cSub afterButton" :class="{active:index==currentIndex}" @click="changeBtn(index)">{{item.title}}</button> -->
					</div>
				</div>
				<Detail @changetree='changetree' v-if="btnGroup.length&&btnGroup[currentIndex].ref=='Details'" :roleCode='roleCode' :basicInfo="basicInfo" @stepTo="stepTo" ref="Details" @stepToDevice="stepToDevice"></Detail>
				<div v-show="btnGroup.length&&btnGroup[currentIndex].ref=='ChildSys'" ref="ChildSys"></div>
				<!-- <ChildSys class='mMeduce' v-if="btnGroup.length&&btnGroup[currentIndex].ref=='ChildSys'" :roleCode="roleCode" :timezone="basicInfo.region.timezone" ref="ChildSys" @refrshDetail="delchildsys" @showDevices="_AddConnectsDevices" @refreshSelect="_getTreeInfo(stationId)" @editConnectDevices="_editConnectDevices"></ChildSys> -->
				<station-info class='mMeduce' v-if="btnGroup.length&&btnGroup[currentIndex].ref=='stationInfo'" :roleCode='roleCode' :finalOutRole="finalOutRoleList" ref="stationInfo" :powerType="'light'"></station-info>
				<relate-info class='mMeduce' v-if="btnGroup.length&&btnGroup[currentIndex].ref=='relateInfo'" ref="RelateInfo" @DelRelBus="confirmDelStation" @AfterDelPersonal="AfterDelPersonal" :powerType="'light'"></relate-info>
				<Alarm v-if="btnGroup.length&&btnGroup[currentIndex].ref=='Alarm'" :type="1" :userFor="'plant'" :plantIdList="[stationId]" :timezone="basicInfo.region.timezone" :startTime="stationInfo.lastUpdateTime" ref="Alarm"></Alarm>
				<Layout v-if="btnGroup.length&&btnGroup[currentIndex].ref=='Layout'" class="mt1x" :roleCode='roleCode' :basicInfo="basicInfo" :timeZoneCode="basicInfo.region.timezone" :collectTime="stationInfo" :time="stationInfo.lastUpdateTime" :stationId='stationId' :systemId='headerInfo.StationSelectValue' :level='systemType' ref='Layout'></Layout>
		        <maintenance class='mMeduce' v-if="btnGroup.length&&btnGroup[currentIndex].ref=='Maintenance'&&!stage.setting.loc.shieldBlackList.maintenance" ref="Maintenance" :systemType="1" :systemTypeId="stationId" :systemTypeName="basicInfo.name"></maintenance>
				<!-- :timezone="basicInfo.region.timezone" :systemTypeId=""-->
			</div>
			<div v-if="systemType==1">
				<!--
				<Confirm ref="confirmDel" @confirm="del"></Confirm> -->
				<div v-if="childSys.ChildBtnGroup.length" class="navBtn pl1x bdSub-bottom-notLast" :class="{disable:!basicInfo.id||!headerInfo.StationSelectValue}">
					<div class="tabBar style-tabBar cb active-c-main_E tra-fast_E">
						<button v-for="(item,index) in childSys.ChildBtnGroup" :key="index" class="cSub afterButton" :class="{active:index==childSys.childIndex}" @click="changeChildBtn(index)">{{item.title}}</button>
					</div>
				</div>
				<ChildDetail :roleCode='roleCode' :StationType="basicInfo.powerType==='PV' ? 'light' : 'wind'" class='mMeduce' v-if="childSys.ChildBtnGroup.length && childSys.ChildBtnGroup[childSys.childIndex].ref=='ChildDetail'" :basicInfo="basicInfo" ref="ChildDetail" @stepToDevice="stepToDevice"></ChildDetail>
				<div v-show="childSys.ChildBtnGroup.length && childSys.ChildBtnGroup[childSys.childIndex].ref=='ChildSysList'" ref="ChildSys"></div>
				<!-- <ChildSys class='mMeduce' v-if="childSys.ChildBtnGroup.length && childSys.ChildBtnGroup[childSys.childIndex].ref=='ChildSysList'" :roleCode="roleCode" ref="ChildSysList" @refrshDetail="DelChildSysSuccess" @addChildSysSuccess="_getTreeInfo(stationId)" @showDevices="_AddConnectsDevices" @editConnectDevices="_editConnectDevices"></ChildSys> -->
				<Alarm v-if="childSys.ChildBtnGroup.length && childSys.ChildBtnGroup[childSys.childIndex].ref=='ChildSysAlarm'" :type="1" :userFor="'plant'" :plantIdList="[stationId]" :timezone="basicInfo.region.timezone" :startTime="stationInfo.lastUpdateTime" :subSystemIdList="[headerInfo.StationSelectValue]" ref="ChildSysAlarm"></Alarm>
			</div>
		</Window>
	</div>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as lib from '@/util/lib'
import Window from '@/components/common/ui/WindowForView.vue'
import Loading from '@/components/common/ui/Loading'
import NoResult from '@/components/common/ui/NoResult'
import StatusIco from '@/components/common/ui/StatusIco'
import Select from '@/components/common/ui/Select.vue'
import AddPerson from '@/view/maintain/light/plant/part/AddPerson.vue' // 添加关联人
import newPlant from '@/view/maintain/light/plant/part/New.vue'
import TagManageForObject from '@/components/common/tagManage/ForObject.vue'
import Detail from '@/view/maintain/light/plant/part/Detail'// 详情
import ChildSys from '@/view/maintain/light/plant/part/ChildSys.vue' // 子系统/设备
import StationInfo from '@/view/maintain/light/plant/part/StationInfo.vue'// 电站信息
import RelevantPerson from '@/view/maintain/light/plant/part/RelevantPerson'// 关联人员
import Equipment from '@/view/maintain/light/plant/part/Equipment'// 设备
import RealData from '@/view/maintain/light/plant/part/ViewRealData'// 实时数据
import ConfirmDevice from '@/components/common/ui/Confirm'
import ConfirmMeterUnconfig from '@/components/common/ui/Confirm' // 电表未配置提醒
import RelevancePart from '@/view/maintain/part/RelevancePart.vue';//授权
//import RepeatWarn from '@/view/maintain/light/plant/part/RepeatWarn'// 数据重复提示
// import MeterSetup from "@/view/maintain/light/plant/part/MeterSetup"   //电表配置
import StationConfig from '@/view/maintain/light/plant/part/StationConfig' // 电站配置
import PromiseList from '@/view/maintain/light/plant/part/PromiseList' // 电站配置
import Alarm from '@/view/maintain/alarm/part/List' // 报警信息
import Layout from '@/view/maintain/light/plant/part/layout/View.vue' // 系统布局
import Maintenance from '@/view/application/maintenance/List'
import NewMaintenance from '@/view/application/maintenance/part/NewMaintenance'
import RelateInfo from '@/view/maintain/plant/relate/List' // 关联信息
import AddContentsDevices from '@/view/maintain/light/plant/part/AddConnectsDevices' // 添加直连设备
import EditConentsDevices from '@/view/maintain/light/plant/part/EditConnectsDevices'

import {getLanguageStr} from '@/util/language'
import {delRelatedBus, delRelatedUser} from '@/api/maintain/plant/relative.js'
import Edit from '@/view/maintain/light/plant/part/layout/Edit';
import ChildDetail from '@/view/maintain/light/plant/part/ChildDetail'// 详情
import AddChildSys from '@/components/common/ChildSysConfig.vue'

import * as maintainApi from '@/api/maintain/plant/list'
//import {dataRepeatHint, configRepeatHint} from '@/api/maintain/config/index'
import {getTags} from '@/api/manage/tag'

import {time} from '@/util'
import Cookies from 'js-cookie'
import Help from '@/components/common/Help.vue'
export default{
	name: 'StationDetail',
	components: {
		NewMaintenance,
		Help,
		Loading,
		NoResult,
		Select,
		Detail,
		StationInfo,
		RelevantPerson,
		Equipment,
		ConfirmDevice,
		ConfirmMeterUnconfig,
		StatusIco,
		RealData,
	 // RepeatWarn,
		StationConfig,
		// MeterSetup,
		Window,
		ChildSys,
		Alarm,Layout,
		Maintenance,//维保记录
		RelateInfo,
		AddContentsDevices,
		EditConentsDevices,
		// 子系统
		ChildDetail,
		AddChildSys,
		AddPerson,
		newPlant,
		TagManageForObject,
		RelevancePart,
		PromiseList
	},
	props: {
		hideB: {
			type: Boolean,
			default: true
		},
		bg:{
			type: Boolean,
			default: false
		}
	},
	provide () {
		return {
			yeye: this
		}
	},
	data () {
		return {
			stage,
			ref:{//保存动态创建的组件
				ChildSys:{//子系统的动态组件
					box:null,
					ref:null
				}
			},
			newMaintentceShow:false,
			id: 'viewPlant',
			headerInfo: {
				stationName: [],
				StationSelectValue: 0,
				labels: [],
				StationSelectName: ''
			},
			AddDeviceLevel: 0,
			following: false,
			stationInfo: {},
			basicInfo: {
				region: {
					timezone: ''
				}
			},
			data: {},
			stationId: '',
			currentIndex: 0, // Tagindex
			systemType: 0, // 记录是否是父子站点
			confirmTitle: '',
			repeatState: false,
			meter: {},
			meterUnconfigList: [],	// 未配置电表

			StationSelectindex: 0,
			SonComponents: { // 控制组件的显示，防止子组件太多，导致页面卡顿
				EditLablesOpen: false,
				stationConfig: false,
				AddDevicesShow: false, // 添加直连设备
				EditDevicesShow: false, // 再次添加直联设备
				delStation: false, // 删除电站
				addPerson: false, // 关联人
				editStation: false, // 编辑电站
				editLables: false // 编辑标签
			},
			copyBtn: [{
					title: getLanguageStr('word734', '详情'),
					ref: 'Details',
					show: true,
					Perms: 'A/B/A6',
					ExterPermas: ''
				},
				{
					title: getLanguageStr('word1968', '子系统/设备'),
					ref: 'ChildSys',
					show: true,
					Perms: 'A/B/A7',
					ExterPermas: 'A3'
				},
				{
					title: getLanguageStr('word27', '报警'),
					ref: 'Alarm',
					show: true,
					Perms: 'A/D/A1',
					ExterPermas: 'A7'
				},
				{
					title:getLanguageStr('word1909','系统布局'),
					ref:"Layout",
					show: true,
					Perms:"A/B/A21",
					ExterPermas:"A9",
					settingLocShow:stage.setting.loc.shieldBlackList.plantLayout
				},
					{
					title:getLanguageStr('word1992','维保记录'),
					ref:"Maintenance",
					show: true,
					Perms:"C/A/A5",
					ExterPermas:"",
					settingLocShow:stage.setting.loc.shieldBlackList.maintenance
				},
				{
					title: getLanguageStr('word1723', '关于电站'),
					ref: 'stationInfo',
					show: true,
					Perms: 'A/B/A12',
					ExterPermas: 'A8'
				},
				{
					title: getLanguageStr('plant67', '授权信息'),
					ref: 'relateInfo',
					show: true,
					Perms: 'A/B/A13',
					ExterPermas: ''
				}],
			defaultBtnGroup: [
				// {
				// 	title: getLanguageStr('word734', '详情'),
				// 	ref: 'Details',
				// 	show: true,
				// 	Perms: 'A/B/A6',
				// 	ExterPermas: ''
				// },
				// {
				// 	title: getLanguageStr('word1968', '子系统/设备'),
				// 	ref: 'ChildSys',
				// 	// dynamic:"ChildSys",//是否动态调用组件
				// 	show: true,
				// 	Perms: 'A/B/A7',
				// 	ExterPermas: 'A3'
				// },
				// {
				// 	title: getLanguageStr('word27', '报警'),
				// 	ref: 'Alarm',
				// 	show: true,
				// 	Perms: 'A/D/A1',
				// 	ExterPermas: 'A7'
				// },
				// {
				// 	title:getLanguageStr('word1909','系统布局'),
				// 	ref:"Layout",
				// 	show: true,
				// 	Perms:"A/B/A21",
				// 	ExterPermas:"A9"
				// },
				// {
				// 	title: getLanguageStr('word1723', '关于电站'),
				// 	ref: 'stationInfo',
				// 	show: true,
				// 	Perms: 'A/B/A12',
				// 	ExterPermas: 'A8'
				// },
				// {
				// 	title: getLanguageStr('word1557', '授权信息'),
				// 	ref: 'relateInfo',
				// 	show: true,
				// 	Perms: 'A/B/A13',
				// 	ExterPermas: ''
				// }
			],
			btnGroup: [],
			childSys: {
				 childIndex: 0,
				 functionType: 'GENERATION',
				 defaultChildBtnGroup:[
					 {
						title: getLanguageStr('plant299', '子系统详情首页'),
						ref: 'ChildDetail',
						show: true,
						Perms: 'A/B/A6',
						ExterPermas: ''
					},
					{
						title: getLanguageStr('word164', '设备'),
						ref: 'ChildSysList',
						dynamic:["ChildSys",ChildSys],//[组件目标dom的ref名字，导入的组件名]
						show: true,
						Perms: 'A/B/A7',
						ExterPermas: 'A3'
					},
					{
						title: getLanguageStr('word27', '报警'),
						ref: 'ChildSysAlarm',
						show: true,
						Perms: 'A/D/A1',
						ExterPermas: 'A7'
					}
				],
				ChildBtnGroup:[]
			},
			filter: {},
			entityRelId: '',
			targetEntityId: '',
			outShow: false,
			roleCode: null, // []
			finalOutRoleList:null//简化后的外部权限列表
		}
	},
	computed: {
		...mapGetters({
			isOpen: 'stationDetail/isOpen',
			// btnGroup:'stationDetail/btnGroup',
			// userFunctions: 'user/userFunctions',
			metering: 'stationDetail/metering'
			// deviceIndex:'stationDetail/deviceIndex'
		}),
		meterIsEmpty () {
			return _.isEmpty(this.meter)
		},
		moreBtnFlags () {
			let buttonPermissions = JSON.parse(window.localStorage.getItem('buttonPermissions'))
			if (!buttonPermissions.includes('A/B/A3')) {
				return false
			} else {
				return true
			}
		},
		moreBtnFlag () {
			let buttonPermissions = JSON.parse(window.localStorage.getItem('buttonPermissions'))
			if (!buttonPermissions.includes('A/B/A4') && !buttonPermissions.includes('A/B/A5')) {
				return false
			} else {
				return true
			}
		},
		relBtn () {
			let buttonPermissions = JSON.parse(window.localStorage.getItem('buttonPermissions'))
			if(this.entityRelId!=null){
				if (!buttonPermissions.includes('A/B/A14')) {
					return false
					} else {
					return true
				}
			}else{
				if (!buttonPermissions.includes('A/B/A14')) {
					return false
					} else {
					return true
				}
			}
		},
		addBtnFlag () {
			let buttonPermissions = JSON.parse(window.localStorage.getItem('buttonPermissions'))
			if (!this.relBtn && !buttonPermissions.includes('A/B/A8')) {
				return false
			} else {
				return true
			}
		},
	//  hasA3 () { // 是否有查看子系统设备的权限
	//    let buttonPermissions = JSON.parse(localStorage.getItem('buttonPermissions'))
	//    let res = false
	//    if (buttonPermissions.includes('A/B/A7')) {
	//      if (this.roleCode && this.roleCode.length) { // 需要在外部权限继续判断
	//        this.roleCode.forEach(el => {
	//          if (el.isOn == 2 && el.code.split('/')[1] == 'A3') {
	//            res = true
	//          } else if (el.code.split('/')[1] == 'A3' && el.isOn != 2) {
	//            res = false
	//          }
	//        })
	//      } else res = true
	//    }
	//    return res
	//  }
	},
	watch: {
		stationId (data) {
			this.isEmpty = _.isEmpty(data)
		},
		data: {
			handler: function(v){
				if (!v.roleCode) {
					this.defaultBtnGroup[3].show = false
					return this.outShow = true
				}
				let codeList = v.roleCode.filter(item => {
					if (item.isOn == 2 && item.code =='OP/A9') {
						return item
					} else if (item.code !=='OP/A9') {
						 return item
					}
				})
				if (codeList.length == 0) {
					this.outShow = false
				} else {
					this.outShow = true
				}
			},
			deep: true
		}
	},
	methods: {
		...mapMutations({
			Get_RECORDID: 'stationDetail/Get_RECORDID',
			// GET_ISEMPTY:'stationDetail/GET_ISEMPTY',
			GET_ISOPEN: 'stationDetail/GET_ISOPEN',
			GET_ISNOTICEBOX: 'inbox/GET_ISNOTICEBOX'
			// GET_DEVICEINDEX:'stationDetail/GET_DEVICEINDEX'
		}),
		judge:lib.judge,
		getLanguageStr,
		getTypeText: lib.getTypeText,
		timeFormat: lib.timeFormat,
		doPermissions: lib.doPermissions,
		objTool: lib.objTool,
		clone (arr) {
			return _.cloneDeep(arr)
    },
    changetree (items) {
      this.headerInfo.stationName.map((item,index)=>{
        if(item.value === items.systemId) {
          this.headerInfo.StationSelectValue = item.value
          this.StationSelect(index)
        }
      })
    },
		buildChildSys:function(part,fn){//动态创建子系统组件
			this.$refs.Window.loadStatusAction(true);
			if(this.ref.ChildSys.box){
				this.ref.ChildSys.box.destroyUi();
				this.ref.ChildSys.box=null;
			}
			this.$nextTick(() => {
				switch(part){
					case "main":
						this.$dynamic(this.$refs.ChildSys,ChildSys,{
							roleCode:this.roleCode,
							timezone:this.basicInfo.region.timezone
						},{
							refrshDetail:[this.delchildsys.bind(this)],
							showDevices:[this._AddConnectsDevices.bind(this)],
							refreshSelect:[this._getTreeInfo.bind(this)],
							editConnectDevices:[this._editConnectDevices.bind(this)]
						}).then(fn);
						break;
					case "child":
						break;
				}
			});
		},
		stepTo (index,tagName) {	//tagName 子页面tab切换索引(string类型，取值范围参考子页面tab数组)
			for (let attr in this.btnGroup) {
				if (this.btnGroup[attr].ref == index) {
					this.changeBtn(attr,tagName)
				}
			}
		},
		editLayout () {
			this.$dynamic($(this.$el).parents("#app").find(".frame-main section").first()[0],Edit,
					{id:this.stationId,systemId:this.headerInfo.StationSelectValue},
					{},{}
				).then(({instance, childInstance}) => {
					childInstance.show(null,this.basicInfo,instance);
				}
			);
		},
		stepToDevice (data) {
			let alarmFlag=false,childSysflag=false;
			this.$nextTick(() => {
				if(data=='alarm'){
					alarmFlag=this.judge(this.entityRelId,'Alarm',this.roleCode)
					if(alarmFlag){
						if(this.systemType == 0){
							this.btnGroup.forEach((val, index) => {
								if (val.ref == 'Alarm') {
									this.currentIndex = index
								}
							})
							this.$nextTick(() => {
								this.$refs.Alarm.show({
									stationId: this.stationId,
									systemId: this.headerInfo.StationSelectValue
								})
							})
						}else{
							this.childSys.ChildBtnGroup.forEach((val, index) => {
									if (val.ref == 'ChildSysAlarm') {
										this.childSys.childIndex = index
									}
							})
							this.changeChildBtn(this.childSys.childIndex)
						}
					}else{
						this.$notify(getLanguageStr('word256+word901', '暂无权限'))
					}
				}else{
					childSysflag=this.judge(this.entityRelId,'ChildSys',this.roleCode)
					if(childSysflag){
						if(this.systemType == 0){
							this.btnGroup.forEach((val, index) => {
								if (val.ref == 'ChildSys') {
									this.currentIndex = index
								}
							});
							this.changeBtn(this.currentIndex,data);
							// this.buildChildSys("main",()=>{
							// 	this.$nextTick(() => {
							// 		this.ref.ChildSys.ref.show({
							// 			stationId: this.stationId,
							// 			systemId: this.headerInfo.StationSelectValue,
							// 			level: this.systemType,
							// 			tag: data
							// 		});
							// 	});
							// });
						}else{
							this.childSys.ChildBtnGroup.forEach((val, index) => {
								if (val.ref == 'ChildSysList') {
									this.childSys.childIndex = index
								}
							});
							this.changeChildBtn(this.childSys.childIndex,data);
							// this.$nextTick(() => {
							// 	this.$refs.ChildSysList.show({
							// 		stationId: this.stationId,
							// 		systemId: this.headerInfo.StationSelectValue,
							// 		level: this.systemType,
							// 		tag: data
							// 	})
							// })
						}
					}else{
						this.$notify(getLanguageStr('word256+word901', '暂无权限'))
					}
				}
			})
		},
		// 匹配状态
		matchNetStatus (val) {
			switch (val) {
				case 'NORMAL':return 1; break
				case 'ALL_OFFLINE':return 0; break
				case 'PARTIAL_OFFLINE':return 0; break
				case 'NO_DEVICE':return null; break
			}
		},
			// 在打开的详情页里面点击图标子系统和报警 type为状态，next为子系统和报警
		statusStepTo (type, next) {
			if (this.systemType == 0) {
				if (next == 'ChildSys') {
					this.btnGroup.forEach((val, index) => {
						if (val.ref == next) {
							this.currentIndex = index
						}
					});
					this.changeBtn(this.currentIndex);
					// this.$nextTick(() => {
						// this.ref.ChildSys.ref.show({
						// 	stationId: this.stationId,
						// 	systemId: this.headerInfo.StationSelectValue,
						// 	level: this.systemType,
						// 	networkStatus: this.matchNetStatus(type)
						// })
					// })
				} else {
					this.btnGroup.forEach((val, index) => {
						if (val.ref == next) {
							this.currentIndex = index
						}
					})
					this.changeBtn(this.currentIndex);
				}
			} else {
				if (next == 'ChildSys') {
					this.childSys.ChildBtnGroup.forEach((val, index) => {
						if (val.ref == 'ChildSysList') {
							this.childSys.childIndex = index;
						}
					});
					this.changeChildBtn(this.childSys.childIndex);//,{level:this.systemType,networkStatus:this.matchNetStatus(type)}
					// this.$nextTick(() => {
					// 	this.ref.ChildSys.refList.show({
					// 		stationId: this.stationId,
					// 		systemId: this.headerInfo.StationSelectValue,
					// 		level: this.systemType,
					// 		networkStatus: this.matchNetStatus(type)
					// 	})
					// })
				} else{
					this.childSys.ChildBtnGroup.forEach((val, index) => {
						if (val.ref == 'ChildSysAlarm') {
							this.childSys.childIndex = index;
						}
					})
					this.changeChildBtn(this.childSys.childIndex);
				}
			}
		},
		showChildSys () {
			this._getStaionInfo(this.headerInfo.StationSelectValue)
			this.changeChildBtn(this.childSys.childIndex)
			// this.$refs.ChildViewDetail.show({
			// 	stationId:this.stationId,
			// 	systemId:this.headerInfo.StationSelectValue,
			// 	level:this.systemType
			// })
		},
		StationSelect (index) {
			statistic('A13','A1351')
			this.StationSelectindex = index
			this.headerInfo.StationSelectName = this.headerInfo.stationName[index].text
			this.headerInfo.StationSelectValue = this.headerInfo.stationName[index].value
			this.childSys.functionType = this.headerInfo.stationName[index].functionType
			// console.log(this.headerInfo.stationName[index])
			this.systemType = this.headerInfo.stationName[index].level
			if (this.systemType == 1) {
				this.childSys.childIndex = 0
				this._getStaionInfo(this.headerInfo.StationSelectValue)
				this.changeChildBtn(this.childSys.childIndex)
			} else {
				this.currentIndex = 0
				this._getStaionInfo(this.stationId)
				this.changeBtn(this.currentIndex)
			}
		},
		getRole () {
			this.btnGroup = []
			this.childSys.ChildBtnGroup = []
			let buttonPermissions = JSON.parse(localStorage.getItem('buttonPermissions'))
			let roleColeList = this.roleCode ? this.roleCode.map(el => ({code: el.code.split('/')[1], isOn: el.isOn})) : [] // 外部关系权限
			let rcode=roleColeList.map((item, index) => {
				return item.isOn?item.code:null;
			});
			// console.log(finalOutRoleList)
			this.finalOutRoleList=rcode.length?rcode:null;
			let outPermission = false
				this.defaultBtnGroup.forEach(val => { // 由于可以无缝切换显示，需要分别设置true和false
					if (buttonPermissions.includes(val.Perms)) { // 总权限
						if (roleColeList.length && val.ExterPermas) { // 外部权限检查
							let pos=rcode.indexOf(val.ExterPermas);
							if(roleColeList[pos]&&roleColeList[pos].isOn==2){
			      val.show = true
			      outPermission = true
							}else{
								val.show = false
							}
						} else {
							val.show = true
						}
					} else {
						val.show = false
					}
				});
				this.childSys.defaultChildBtnGroup.forEach(val => {
					if (buttonPermissions.includes(val.Perms)) {
						if (roleColeList.length && val.ExterPermas) {
							let pos=rcode.indexOf(val.ExterPermas)
							if(pos!==-1&&roleColeList[pos].isOn==2){
			        val.show = true
			        outPermission = true
							}else{
								val.show = false
							}
						} else {
							val.show = true
						}
					} else {
						val.show = false
					}
			});
			if(!outPermission){

			}
			this.btnGroup = _.cloneDeep(this.defaultBtnGroup).filter(el => el.show||el.Perms=="");//如果权限码为空，始终显示
			if (!this.outShow) {
				this.btnGroup = this.btnGroup.filter(item => {
					if (item.ref!=='Layout') {
						return item
					}
				});
			}
			this.childSys.ChildBtnGroup = _.cloneDeep(this.childSys.defaultChildBtnGroup).filter(el => el.show)
		},
		isFollowing (id) {
			maintainApi.PostFollow(id).then(res => {
				this.following = res
			}, error => {
				!_.isEmpty(error) && this.$notify(error)
			});
		},
		_getStaionInfo (id) {
			let buttonPermissions = JSON.parse(localStorage.getItem('buttonPermissions'))
			maintainApi.StationInfo(id).then(response => {
				this.stationInfo = response
				if (this.systemType == 0) {
					if (JSON.stringify(this.filter) != '{}') {
						this.statusStepTo(this.filter.status, this.filter.type)
					} else {
						this.changeBtn(this.currentIndex)
					}
				}
			}, error => {
				if (error === '没有操作权限') {
					// 暂时隐藏，详情打开后再次关闭
					// !_.isEmpty(error) && this.$notify(error)
					// this.$refs.ViewDetail.hide()
				} else {
					!_.isEmpty(error) && this.$notify(error);
					this.hide();
				}
			})
		},
		_getBasicInfo (id, end) {
			maintainApi.StationBasicInfo(id).then(response => {
        this.basicInfo = response
				this.roleCode = response.roleCode
				this.entityRelId = response.entityRel ? response.entityRel.id : null
				 if(!this.data.entityRel){this.data.entityRel=response.entityRel?response.entityRel:null}
				if (end) end()
			}, error => {
				!_.isEmpty(error) && this.$notify(error)
			})
		},
		// 点击切换
		_isFollowing () {
			maintainApi.apiSetFollow([this.stationId], !this.following).then(res => {	// api
				this.following = !this.following
				this.$emit('Follow', this.stationId, this.following)
				// if(this.isOpen){
				// 	this.$refs.ViewDetail.data.following=isFollow
				// }
				// followOrUnfollow()
			}, error => {
				!_.isEmpty(error) && this.$notify(error)
			})
		},
		// 重置下来选择
		resetSelect () {
			this.headerInfo.StationSelectValue = 0
			this.StationSelectindex = 0
			this.systemType = 0 // 打开恢复为父系统显示
			this.headerInfo.stationName = [] // 下拉选择置空
		},
		_getTreeInfo (id, nowTreeid) {
      let ids = id || this.stationId
      // console.log(ids,id,this.stationId)
			maintainApi.StationStructure(ids).then(res => {
				let children = res.children
				let childrenList = []
				if (children.length) {
					childrenList = children.map(el => ({
						text: el.name,
						value: el.id,
						level: el.level,
						functionType: el.functionType
					}))
				}
				childrenList.unshift({text: res.name, value: res.id, level: res.level, functionType: null})
				this.headerInfo.stationName = childrenList
				if (this.systemType == 0) {
					this.headerInfo.StationSelectValue = res.id
        }
       
				let SelectOnce = this.headerInfo.stationName.filter(el => { return this.headerInfo.StationSelectValue == el.value })
				this.headerInfo.StationSelectName = SelectOnce[0].text
        this.childSys.functionType=SelectOnce[0].functionType;//修改子系统发电用电显示
        if (nowTreeid) {
       
          this.StationSelect(this.headerInfo.stationName.length-1)
        }
			}, error => {
				!_.isEmpty(error) && this.$notify(error)
			})
		},
		_getLabel (data) {
			let buttonPermissions = JSON.parse(localStorage.getItem('buttonPermissions'))

			if (!buttonPermissions.includes('A/B/A16')) {
				return false
			} else {
				getTags(data, 1).then(res => {
					this.headerInfo.labels = res
				}, error => {
					!_.isEmpty(error) && this.$notify(error)
				})
			}
		},
		changeBtn (index,tagName) {
			this.currentIndex = index;
			if (this.btnGroup.length && this.btnGroup[this.currentIndex].ref == 'Details') {
				this.$nextTick(() => {
					this.$refs.Details.show({
						stationId: this.stationId,
						systemId: this.headerInfo.StationSelectValue,
						stationInfo: this.stationInfo,
						level: this.systemType
					})
				})
			} else if (this.btnGroup.length && this.btnGroup[this.currentIndex].ref == 'ChildSys'){
				this.buildChildSys("main",({instance,childInstance})=>{
					this.ref.ChildSys={box:instance,ref:childInstance};
					this.ref.ChildSys.ref.show({
						stationId: this.stationId,
						systemId: this.headerInfo.StationSelectValue,
						level: this.systemType,
						tag:tagName?tagName:null	//设置子设备层中切换索引
					});
					this.$refs.Window.loadStatusAction(false);
				});
				// this.ref.ChildSys.ref.show({
				// 	stationId: this.stationId,
				// 	systemId: this.headerInfo.StationSelectValue,
				// 	level: this.systemType,
				// 	tag:tagName?tagName:null	//设置子设备层中切换索引
				// })
			} else if (this.btnGroup.length && this.btnGroup[this.currentIndex].ref == 'stationInfo') {
				this.$nextTick(() => {
					this.$refs.stationInfo.show({
						stationId: this.stationId,
						systemId: this.headerInfo.StationSelectValue
					})
				})
			} else if (this.btnGroup.length && this.btnGroup[this.currentIndex].ref == 'relateInfo') {
				this.$nextTick(() => {
					this.$refs.RelateInfo.show({
						stationId: this.stationId,
						systemId: this.headerInfo.StationSelectValue,
						entityRelIds: this.entityRelId
					})
				})
			} else if (this.btnGroup.length && this.btnGroup[this.currentIndex].ref == 'Alarm') {
				this.$nextTick(() => {
					this.$refs.Alarm.show()
				})
			}else if (this.btnGroup.length && this.btnGroup[this.currentIndex].ref == 'Maintenance') {
				this.$nextTick(() => {
					this.$refs.Maintenance.getList()
				})
			}
		},
		//添加维保记录
		addMaintenance(type,id){
			this.newMaintentceShow=true
			this.$nextTick(() => {
				this.$refs.NewMaintenance.show()
			})
		},
		// 子系统
		changeChildBtn (index,tagName) {
			this.childSys.childIndex = index
			this.$nextTick(() => {
				if (this.childSys.ChildBtnGroup.length){
					let option={
						stationId: this.stationId,
						systemId: this.headerInfo.StationSelectValue,
						level:this.systemType,
						functionType: this.childSys.functionType,
						tag:tagName
					};
					// $.extend(true,option,optionForDynamicShow);
					let ref=this.childSys.ChildBtnGroup[this.childSys.childIndex];
					if(ref.dynamic){
						this.$refs.Window.loadStatusAction(true);
						if(this.ref[ref.dynamic[0]].box){
							this.ref[ref.dynamic[0]].box.destroyUi();
							// this.ref[ref.dynamic[0]].box=null;
						}
						this.$dynamic(this.$refs[ref.dynamic[0]],ref.dynamic[1],{
							roleCode:this.roleCode
						},{
							refrshDetail:[this.DelChildSysSuccess.bind(this)],
							addChildSysSuccess:[(()=>{this._getTreeInfo(this.stationId);}).bind(this)],
							showDevices:[this._AddConnectsDevices.bind(this)],
							editConnectDevices:[this._editConnectDevices.bind(this)]
						}).then(({instance,childInstance})=>{
							this.ref[ref.dynamic[0]].box=instance;
							this.ref[ref.dynamic[0]].ref=childInstance;
							this.ref[ref.dynamic[0]].ref.show(option);
							this.$refs.Window.loadStatusAction(false);
						});
					}
					else{
						this.$refs[ref.ref].show(option);
					}
				}
			})
		},
		_judgeMeterConfig () {
			// if(this.userFunctions.includes('A/C/A')) {
			maintainApi.MeterUnconfigured(this.stationId).then(response => {
				if (!response.length || !response) {
					this.meterUnconfigList = []
				} else {
					// 判断cookie 中是否true
					let flag = Cookies.get(`${this.stationId}-meterConfig-notShow`)
					if (flag) return
					this.$refs.confirmMeterUnconfig.show({
						text: getLanguageStr('meter_configure1', '系统检测到你的电站中存在未配置的电表设备，请点击“去配置”以完成电表配置，否则电表数据将不能体现在电站。')
					})
					this.meterUnconfigList = response
				}
				// console.log(this.meterUnconfigList)
			}, error => {
				!_.isEmpty(error) && this.$notify(error)
			})
			// }
		},
		_meterSetup (meterInfo) {
			this.$refs.confirmMeterUnconfig.hide()
			this.meter = _.cloneDeep(meterInfo)
			this.$nextTick(() => {
				this.$refs.meterSetup.open()
			})
		},
		// 不再显示电表配置
		notShowMeterConfig () {
			Cookies.set(`${this.stationId}-meterConfig-notShow`, true)
		},
		// 打开
		renovation(data){
      if (!data) return
			let renovationData=$.extend(true,{},data,{fromType:'renovation'})
			this.show(renovationData)
		},
		show (data,list,dynamic) {
			this.defaultBtnGroup = this.copyBtn
			if(!data.fromType){
				this.filter={}
				if (!data.filter) {
					this.currentIndex=0
					this.filter={}
				}else{
					this.filter=data.filter
				}
			}
			this.dynamic=dynamic?dynamic:list;
			this.$refs.Window.loadStatusAction(true)
			this.$refs.Window.show({end: () => {
				this.data = data;
				this.stationId = data.id
				this.repeatState = false
				for (let attr in this.SonComponents) {
					this.SonComponents[attr] = false
				}
				this.GET_ISOPEN(true)
				this.resetSelect()
				// if (data.hasOwnProperty('entityRel')) { // 新建单站和编辑电站后，data的格式是{id:**}
				// 	this.data = data
				// 	this.entityRelId = data.entityRel.id
				// 	// this.roleCode=data.roleCode
				// } else {
				// 	this.data = {
				// 		id: data.id,
				// 		entityRel: {
				// 			id: this.entityRelId ? this.entityRelId : ''
				// 		},
				// 		// roleCode:this.roleCode.length?this.roleCode:null
				// 	}
				// 	this.entityRelId = ''
				// }
				this._getBasicInfo(this.stationId, () => {
					this.getRole()
					this.isFollowing(data.id);
					this.$refs.Window.loadStatusAction(false)
					this._getTreeInfo(this.stationId)
					// if(this.roleCode.length){
					// 	this.roleCode.forEach(el=>{
					// 		if(el.isOn==2 && el.code.split('/')[1]=='A3'){
					// 			this._getTreeInfo(this.stationId)
					// 		}
					// 	})
					// }else{
					// 	this._getTreeInfo(this.stationId)
					// }
					this._getStaionInfo(this.stationId)

					this._getLabel(this.stationId)
					// 打开详情判断电表是否配置  没有配置需要给出弹出框提醒
					this._judgeMeterConfig()
					this.btnGroup[this.currentIndex].ref=='Layout' && this.$refs.Layout.fillreset()
				})
			}})
		},
		closePage () {
			this.$emit('closePage')
		},
		hide () {
			this.$refs.Window.hide()
		},
		resetData () {
			this.$refs.Details._fillHeight()
			this.$refs.Details._getAssignInfo(this.stationId)
		},
		myClose () {
			this.filter = {}
			this.GET_ISOPEN(false)
      this.GET_ISNOTICEBOX(false)
			setTimeout(() => {
				this.currentIndex = 0
			}, 500)
			this.$emit('Close');
			if (this.dynamic) this.dynamic.destroyUi()
		},
		// 刷新详情
		_refresh () {
			this.$emit('refresh', this.data)
		},
		delchildsys () {
			this.currentIndex=1;
			this.show({id: this.stationId,filter:{type:'ChildSys'}});
		},
		update () {
			this.resetData()
			this.$emit('update')
		},
		// 数据来源提示
//  _repeatHint () {
//    dataRepeatHint(this.stationId).then(response => {
//      // console.log(response)
//    }, error => {
//      if (error == '重复数据源') {
//        this.repeatState = true
//      }
//    })
//  },
//  // 数据来源重复提示弹框
//  repeatShow () {
//    this.$refs.repeatWarn.show()
//  },
		// 数据来源跳转
		repeatSet () {
			this.$refs.stationConfig.show({name: getLanguageStr('word1722', '数据来源设置'), key: 'source'},$.extend(true,{},this.basicInfo), 2, this.stationId);
		},
		_stageConfig () {
			// <station-config ref="stationConfig" @refreshOffset="_refresh" :basicInfo="basicInfo" v-if="SonComponents.stationConfig" :powerType="'light'" :systemId="stationId"></station-config>
			// this.SonComponents.stationConfig = true
			// this.$nextTick(() => {
			// 	this.$refs.stationConfig.show();
			// });
			this.$dynamic($(this.$el),StationConfig,{bg: true,basicInfo:this.basicInfo,powerType:'light',systemId:this.stationId},
				{'refreshOffset': [this._refresh.bind(this)],
			}).then(({instance, childInstance})=>{
				childInstance.show({},$.extend(true,{},this.basicInfo), 1, this.stationId,instance)
			})
	
		},
		// 删除所有设备后提示
		comfirmRepeat (type) {
			let data = {
				text: ''
			}
			// this.$refs.equipment.currentIndex==2
			if (type == 'meter') {
				data.text = i18n.t('fill109', [i18n.t('fill3rd110', [getLanguageStr('word39', '电表'), '删除了电站内所有电表']), getLanguageStr('word1364', '数据来源'), getLanguageStr('word1362', '系统智能选择'), '您已删除了电站内所有电表，建议将数据来源设置为系统智能选择'])
			} else if (type == 'inverter') {
				data.text = i18n.t('fill109', [i18n.t('fill3rd110', [getLanguageStr('word35', '逆变器'), '删除了电站内所有电表']), getLanguageStr('word1364', '数据来源'), getLanguageStr('word1362', '系统智能选择'), '您已删除了电站内所有逆变器，建议将数据来源设置为系统智能选择'])
			}
			this.$refs.confirmRepeatSet.show(data)
		},
		// 数据来源不再提示
//  noReminder () {
//    configRepeatHint(this.stationId, false).then(response => {
//      this.repeatState = false
//    }, error => {
//      !_.isEmpty(error) && this.$notify(error)
//    })
//  },
		// 电表配置成功回调
		meterSetSuccess () {
			this.$refs.equipment.changeTab(1)
			if (this.metering.statisticMethodSettingStrategy == 'STATIC') {
				let data = {
					text: i18n.t('fill109', [getLanguageStr('phrase606', '修改了电表配置'), getLanguageStr('word1362', '系统智能选择'), '您已修改了电表配置，建议将数据来源设置为系统智能选择'])
				}
				this.$refs.confirmRepeatSet.show(data)
			}
			// this.repeatSet()
		},
		// 数据来源测试，系统自动选择
		systemSel () {
			let request = {
				strategy: 'DYNAMIC'
			}
			maintainApi.StationMeteringStrategy(this.metering.powerStationId, request).then(res => {
				this._refresh()
			}, error => {
				!_.isEmpty(error) && this.$notify(error)
			})
		},
		// 编辑子系统
		editChildSys () {
			let req = {
				functionType: this.childSys.functionType,
				parentId: this.stationId,
				id: this.headerInfo.StationSelectValue,
				name: this.headerInfo.StationSelectName
			}
			this.$refs.AddChildSys.modeChange('edit')
			this.$refs.AddChildSys.show({
				node: req
			})
		},

		// 编辑子系统后刷新头
		refreshChildSys () {
			this._getTreeInfo(this.stationId)
				setTimeout(() => {
					if (this.childSys.childIndex == 0) {
						this.changeChildBtn(0)
					}
				}, 500);
			if (this.childSys.childIndex == 1) {
				this.changeChildBtn(1)
			}
		},
		delChildSys () {
			 this.$refs.confirmDelChild.show({
				text: getLanguageStr('phrase640', '确定要删除子系统吗？这将导致子系统所有历史数据丢失，请谨慎操作！')
			})
		},
		delChild () {
			maintainApi.DeleteChildSys(this.headerInfo.StationSelectValue).then(res => {
				this.DelChildSysSuccess()
			}, error => {
				!_.isEmpty(error) && this.$notify(error)
			})
		},
		// 添加直连设备
		_AddConnectsDevices (id, level) {
			this.AddDeviceLevel = level
			if (level == 1) {
				this.$refs.AddContentsDevices.show({
					stationId: this.stationId
					// systemId:id
				})
			} else {
				this.$refs.AddContentsDevices.show({
					stationId: id
				})
			}
		},
		AddDeviceSuccess () {
			if (this.AddDeviceLevel == 0) { // 父系统下添加直连设备
			  
				this.ref.ChildSys.ref.refreshDevice()
				// this.show({id: this.stationId})
			} else {
				if (this.systemType == 0) { // 父系统下子系统添加
					this.ref.ChildSys.ref.refreshDevice()
				} else { // 子系统下添加
					this.ref.ChildSys.refList.refreshDevice()
				}
			}
		},
		// 子设备
		_editConnectDevices (id, level) {
			this.AddDeviceLevel = level
			this.SonComponents.AddDevicesShow = true
			setTimeout(() => {
				this.$refs.EditConentsDevices.show({
					stationId: id
				})
			}, 10)
		},
		DelChildSysSuccess () {
			this.currentIndex = 0
			this.systemType = 0
			this.show({id: this.stationId})
		},
		// 删除电站
		delStation () {
			this.SonComponents.delStation = true
			this.$nextTick(() => {
				if (this.entityRelId) {
					this.$refs.confirmDelStation.show({
						title:getLanguageStr('manage14','删除电站'),
						text: getLanguageStr('phrase707', '确认将该电站从本商家删除吗？删除后，本商家下所有成员将无法看到该电站但不影响其他商家和用户查看该电站。'),
						ids: this.entityRelId
					});
				} else {
					this.$refs.confirmDelStation.show({
						title:getLanguageStr('manage14','删除电站'),
						text: getLanguageStr('plant_delete12','确定要删除电站吗？这将导致电站所有历史数据丢失，请谨慎操作！'),
						ids: this.stationId
					});
				}
			});
		},
		// 确认删除
		confirmDelStation (data) {
			if (this.entityRelId) {
				if (this.data.entityRel.targetEntityType == 1) { // 解除商家
					delRelatedBus(this.stationId, this.data.entityRel.id).then(res => {
						this.$emit('refreshList');
						this.$emit("Delete");
						// this.myClose()
						this.hide()
					}, error => {
						!_.isEmpty(error) && this.$notify(error)
					})
				} else { // 解除用户
					delRelatedUser(this.stationId, this.data.entityRel.id).then(res => {
						this.$emit('refreshList')
						this.$emit("Delete");
						// this.myClose()
						this.hide()
					}, error => {
						!_.isEmpty(error) && this.$notify(error)
					})
				}
			} else {
				maintainApi.apiDeletePlant([data.ids]).then((success) => {
					this.$emit('refreshList')
					this.$emit("Delete");
					// this.myClose()
					this.hide()
				}, error => {
					!_.isEmpty(error) && this.$notify(error)
				})
			}
		},
		// 添加关联
		_AddRetativePerson () {
			this.$refs.RelevancePart.show([this.stationId], 'single', [this.entityRelId])
			// this.SonComponents.addPerson = true
			// this.$nextTick(() => {
			//   this.$refs.AddPerson.show({
			//     personId: [this.stationId],
			//     title: 'single'
			//   })
			// })
		},
		UpdateRelevance () {
			if (this.btnGroup[this.currentIndex].ref == 'relateInfo') {
				this.show({id: this.stationId})
			}
		},
		refreshPersonList () {
			if (this.btnGroup[this.currentIndex].ref == 'relateInfo') {
				this.changeBtn(this.currentIndex)
			}
		},
		// 编辑电站
		editStation () {
			// $emit('Edit',stationId)
			this.SonComponents.editStation = true
			maintainApi.apiGetPlantDetail(this.stationId, {language: stage.languageId}).then((success) => {
				this.$refs.newPlant.modeChange('edit', this.stationId, success)
				this.$nextTick(() => {
					this.$refs.newPlant.open(success)
				})
			}, error => {
				!_.isEmpty(error) && this.$notify(error)
			})
		},
		AfterEdit () {
			this.show({id: this.stationId})
			this.$emit('refreshList')
		},
		// 编辑标签
		editLables () {
			this.SonComponents.editLables = true
			this.$nextTick(() => {
        // this.$refs.TagManage.show(this.stationId)
        this.$dynamic(this.$el,TagManageForObject,{type:1},{Update:[this.UpdateTags]},{}).then(({instance, childInstance})=>{
            childInstance.show(this.stationId,instance)
        })
			})
		},
		UpdateTags () {
			this._getLabel(this.stationId)
			this.$emit('refreshList')
		},
		AfterDelPersonal () {
			this.hide()
			this.$emit('refreshList')
		}
  },
  destoryed () {
    this.$bus.$off('refreshSelect')
    this.$bus.$off('refreshSelectAll')
  },
	mounted () {
    // lib.setScroll($(this.$el).find(".unconfigList[scroll]"));
    let that = this
    this.$bus.$on('refreshSelect',this._getTreeInfo)
    this.$bus.$on('refreshSelectAll',function () {that.renovation(that.data)})
    // console.log(11111111111)
	}
}
</script>
<style lang="scss" scoped>
//@import '~@/style/definition.scss';
.statueIcon{vertical-align: middle;margin: -3px 5px 0 0;}
// .statueIcon /deep/ .dvStatus{width: 1.2em;height: 1.2em;}
button::-moz-focus-inner { border: 0; }
.miniHelp{
	margin-left: 0!important;
	>svg{
		transform:scale(0.8)!important;
		-webkit-tranform:scale(0.8)!important;
	}
}

</style>



// WEBPACK FOOTER //
// src/view/maintain/light/plant/ViewDetail.vue